import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Confirmation({ route }) {
  const location = useLocation();

  const [date, setDate] = useState();

  const [ubications, setUbications] = useState([
    {
      name: "Grupo Chili Guajili",
      address:
        "Cuarta Priv. de la Noria 108, Barrio de la Noria, 68000 Oaxaca de Juárez, Oax.",
      frame:
        "https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Avenida%20Universidad%2068130%20oaxaca%20Chili%20Guajili+(Chili%20guajili%20universidad)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed",
    },
    {
      name: "Grupo Guajaqueñisimo",
      address: "Cuarta Priv. de la Noria 108, Barrio de la Noria, 68000 Oaxaca de Juárez, Oax.",
      frame:
        "https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Avenida%20Universidad%2068130%20oaxaca%20Chili%20Guajili+(Chili%20guajili%20universidad)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed",
    },
  ]);

  useEffect(() => {
    console.log(location.state);
    const date = new Date(
      location.state.interviewDate + " " + location.state.applicationTime
    );
    console.log("date");
    console.log(date);
    setDate(
      new Intl.DateTimeFormat("es-MX", {
        dateStyle: "full",
        timeStyle: "medium",
      }).format(date)
    );
    return () => {};
  }, []);

  return (
    <div className="min-vh-100 d-flex flex-column">
      {/* Header Navigation */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center">
            <img
              src="../../../../assets/img/logo/logo_chili_rojo.png"
              alt="Chili Guajili Logo"
              height="40"
              className="me-2"
            />
            <span className="fw-bold">Chili Guajili</span>
          </a>
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-grow-1 py-5" style={{ backgroundColor: "#f3f4f6" }}>
        <div className="container-fluid px-4 px-lg-5">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="row g-4">
                {/* Columna izquierda: cita, documentos, ayuda */}
                <div className="col-12 col-lg-6">
              {/* Success Card */}
              <div className="card shadow-lg border-0 mb-3">
                    <div className="card-body text-center px-4 px-lg-5">
                  <div className="mb-4">
                    <img
                      src="../assets/img/Ok.png"
                      alt="Success"
                      className="img-fluid"
                      style={{ maxWidth: "120px" }}
                    />
                  </div>

                  <h1 className="text-success fw-bold mb-3">
                    <i className="fas fa-check-circle me-2"></i>
                    ¡Cita Confirmada!
                  </h1>

                  <div className="alert alert-primary border-0 shadow-sm">
                    <h4 className="alert-heading mb-2">
                      <i className="fas fa-calendar-alt me-2"></i>
                      Fecha y Hora de tu Cita
                    </h4>
                    <p className="fs-5 fw-semibold mb-0">{date}</p>
                  </div>
                </div>
              </div>

              {/* Requirements Card */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-warning text-dark">
                  <h3 className="card-title mb-0">
                    <i className="fas fa-clipboard-list me-2 py-2"></i>
                    Documentos Requeridos
                  </h3>
                </div>
                <div className="card-body">
                  <p className="text-muted mb-4">
                    Por favor, no olvides traer los siguientes documentos:
                  </p>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <div className="d-flex align-items-center p-3 bg-light rounded">
                        <i className="fas fa-id-card text-primary fs-3 me-3"></i>
                        <span className="fw-semibold">
                          Identificación oficial
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="d-flex align-items-center p-3 bg-light rounded">
                        <i className="fas fa-home text-success fs-3 me-3"></i>
                        <span className="fw-semibold">
                          Comprobante de domicilio
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="d-flex align-items-center p-3 bg-light rounded">
                        <i className="fas fa-file-alt text-info fs-3 me-3"></i>
                            <span className="fw-semibold">
                              Solicitud de empleo
                            </span>
                      </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Contact Info Card */}
                  <div className="card shadow border-0 mb-3">
                    <div className="card-body text-center">
                      <h5 className="card-title">
                        <i className="fas fa-phone me-2 text-success"></i>
                        ¿Necesitas ayuda?
                      </h5>
                      <p className="text-muted mb-3">
                        Si tienes alguna pregunta o necesitas reprogramar tu
                        cita, no dudes en contactarnos.
                      </p>
                      <div className="d-flex justify-content-center gap-3">
                        <Link
                          to="https://api.whatsapp.com/send/?phone=529512733559&text=Hola%21%2C+tengo+una+duda+con+mi+cita&type=phone_number&app_absent=0"
                          className="btn btn-outline-success"
                        >
                          <i className="fab fa-whatsapp me-2"></i>
                          WhatsApp
                        </Link>
                    </div>
                  </div>
                </div>
              </div>

                {/* Columna derecha: ubicación */}
                <div className="col-12 col-lg-6">
                  <div className="card shadow border-0 h-100">
                <div className="card-header bg-info text-white">
                  <h3 className="card-title mb-0">
                    <i className="fas fa-map-marker-alt me-2 py-2"></i>
                    Ubicación de la Cita
                  </h3>
                </div>
                    <div className="card-body d-flex flex-column">
                  <div className="alert alert-info border-0 mb-4">
                    <h5 className="alert-heading">
                      <i className="fas fa-building me-2"></i>
                      {location.state.bussinameName}
                    </h5>
                    <p className="mb-0">
                      <i className="fas fa-map-pin me-2"></i>
                      {
                        ubications.find(
                          (u) => u.name === location.state.bussinameName
                        )?.address
                      }
                    </p>
                  </div>

                  {/* Map Container */}
                      <div className="ratio ratio-16x9 rounded overflow-hidden shadow flex-grow-1">
                    <iframe
                      src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Cuarta%20Priv.%20de%20la%20Noria%20108,%20Barrio%20de%20la%20Noria,%2068000%20Oaxaca%20de%20Ju%C3%A1rez,%20Oax.+(Chili%20Oficinas)&amp;t=&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Ubicación Chili Guajili"
                    ></iframe>
                  </div>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer
        className="w-1000px h-75px mt-4"
        style={{
          backgroundImage: "url(../../../assets/img/footer/footer-chili.png)",
          backgroundRepeat: "repeat-x",
          position: "relative",
          bottom: "0",
          width: "100%",
          zIndex: "100",
        }}
      ></footer>
    </div>
  );
}

export default Confirmation;
